import React, { useEffect } from "react";
import { getStoredLogo } from "../../utils/logo";
import {
  FaChalkboard,
  FaListAlt,
  FaCloudUploadAlt,
  FaUserGraduate,
  FaSearch,
  FaUsers,
  FaCheckCircle,
  FaVrCardboard,
  FaTeamspeak,
  FaHammer,
  FaBan,

} from "react-icons/fa";
import { FiRefreshCw, FiX } from "react-icons/fi";
import {
  IoMdSettings,
  IoMdCheckmarkCircleOutline,
  IoIosList,

} from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { MdAutoGraph, MdFiberNew } from "react-icons/md";
export default function LeftMenu(props) {
  const roleId = parseInt(window.localStorage.getItem("role_id"));
  const isAdminRole = roleId === 1 || roleId === 2 || roleId === 5;
  const navigate = useNavigate();

  return (
    <div className={`sidenav ${props.menuClick ? "sidenav-toggle" : ""}`}>
      <div className="sidenav-header">
        <FiX
          style={{
            fontSize: "20px",
            right: "8px",
            top: "8px",
            cursor: "pointer",
          }}
          className="text-secondary opacity-50 position-absolute d-xl-none"
          onClick={() => props.closeMenu()}
        />
        <a className="navbar-brand m-0" onClick={() => navigate("/dashboard/dashboardMain")} >
          <div className="xilliHeadTop">
            <img
              src={getStoredLogo()}
              alt="logo"
              width="100"
              height="auto"
              className="img-fluid"
              style={{ marginLeft: "40px" }}
            />
          </div>
          {/* <img
            src={Logo}
            className="navbar-brand-img img-fluid d-block mx-auto"
            alt="main_logo"
            width={140}
            height="auto"
          /> */}
        </a>
      </div>
      <hr className="horizontal mt-0"></hr>
      <ul className="navbar-nav sidenav-nav">
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className="sidenav_link"
            onClick={() => navigate("/dashboard/dashboardMain")}
            // href="/dashboard/dashboardMain"
            id="DashboardMenu"
          >
            <FaChalkboard title="Dashboard" className="text-priamry" />
            <span>Dashboard</span>
          </a>
        </li>
        {roleId === 1 || roleId === 2 ? (
          <li className="nav-item" style={{ cursor: "pointer" }}>
            <a
              className="sidenav_link"
              onClick={() => navigate("/dashboard/analytics-dashboard")}
              id="AnalyticsDashboard"
            >
              <FaChalkboard title="Dashboard" className="text-priamry" />
              <span>Managers Analytics</span>
            </a>
          </li>
        ) : roleId === 5 ? (
          <li className="nav-item" style={{ cursor: "pointer" }}>
            <a
              className="sidenav_link"
              onClick={() => navigate("/dashboard/analytics-dashboardtwo")}
              id="AnalyticsDashboardTwo"
            >
              <FaChalkboard title="Dashboard" className="text-priamry" />
              <span> Recruiters Analytics</span>
            </a>
          </li>
        ) : null}
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className="sidenav_link"
            // href="/schedule/createJobOpening"
            onClick={() => navigate("/schedule/createJobOpening")}
            id="NewVacancyMenu"
          >
            <FaUserGraduate title="Create Job " className="text-dark" />
            <span>New Requirement</span>
          </a>
        </li>

        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className="sidenav_link"
            // href="/dashboard/searchResult"
            onClick={() => navigate("/dashboard/searchResult")}
            id="JobSearchMenu"
          >
            <FaSearch title="Job Search " className="text-warning" />
            <span>Candidates </span>
          </a>
        </li>
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className="sidenav_link"
            // href="/dashboard/reports"
            onClick={() => navigate("/dashboard/reports")}
            id="DashboardMenu"
          >
            <MdAutoGraph title="Dashboard" className="text-priamry" />
            <span>Reports</span>
          </a>
        </li>
        {isAdminRole && (
          <>
            <li className="nav-item" style={{ cursor: "pointer" }}>
              <a
                className="sidenav_link"
                // href="/fileUpload/resumeUpload"
                onClick={() => navigate("/fileUpload/resumeUpload")}
                id="ResumeUploadMenu"
              >
                <FaCloudUploadAlt
                  title="Resume Upload"
                  className="text-success"
                />
                <span>Resume Upload</span>
              </a>
            </li>
            <li className="nav-item" style={{ cursor: "pointer" }}>
              <a
                className="sidenav_link"
                //href="/fileUpload/resumeBulkUpload"
                onClick={() => navigate("/fileUpload/resumeBulkUpload")}
                id="ResumeBulkUploadMenu"
              >
                <FaCloudUploadAlt
                  title="Resume Bulk Upload"
                  className="text-info"
                />
                <span>Resume Bulk Upload</span>
              </a>
            </li>
          </>
        )}


        {/* <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className="sidenav_link"
            // href="/schedule/createJobOpening"
            onClick={() => navigate("/Designations")}
            id="NewVacancyMenu"
          >
            <FaVrCardboard title="Create Job " className="text-dark" />
            <span>Job Title</span>
          </a>
        </li> */}
        {/* <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className="sidenav_link"
            onClick={() => navigate("/Departments")}
            id="NewVacancyMenu"
          >
            <FaTeamspeak title="Create Job " className="text-dark" />
            <span>Departments</span>
          </a>
        </li> */}
        {/* <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className="sidenav_link"
            onClick={() => navigate("/Skillset")}
            id="NewVacancyMenu"
          >
            <FaHammer title="Create Skills " className="text-dark" />
            <span>Skillset</span>
          </a>
        </li> */}

        {isAdminRole && (
          <li className="nav-item" style={{ cursor: "pointer" }}>
            <a
              className="sidenav_link"
              //href="/initialProcess"
              onClick={() => navigate("/initialProcess")}
              id="ProcessingMenu"
            >
              <FiRefreshCw title="Openings" className="text-danger" />
              <span>My Jobs</span>
            </a>
          </li>
        )}
        {/* <li className="nav-item">
          <a
            className="sidenav_link"
            href="/dashboard/new-requirement"
            id="NewRequirement"
          >
            <MdFiberNew title="New Requirement" className="text-primary" />
            <span>New Requirement</span>
          </a>
        </li>
        <li className="nav-item">
          <a
            className="sidenav_link"
            href="/new-requirement/processing"
            id="RequirementProcessing"
          >
            <MdFiberNew
              title="Requirement Processing"
              className="text-primary"
            />
            <span>Requirement Processing</span>
          </a>
        </li> */}
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className="sidenav_link"
            //href="/schedule/schedules"
            onClick={() => navigate("/schedule/schedules")}
            id="ScheduleMenu"
          >
            <FaListAlt title="Schedules" className="text-primary" />
            <span>Schedule </span>
          </a>
        </li>
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a
            className="sidenav_link"
            // href="/dashboard/candidatestatus"
            onClick={() => navigate("/dashboard/candidatestatus")}
            id="candidatestatusMenu"
          >
            <FaListAlt title="candidatestatus" className="text-warning" />
            <span>Candidate Status </span>
          </a>
        </li>
        {isAdminRole && (
          <li className="nav-item" style={{ cursor: "pointer" }}>
            <a
              className="sidenav_link"
              onClick={() => navigate("/onBoard")}
              //href="/onBoard"
              id="OnBoarding"
            >
              <FaCheckCircle title="OnBoarding" className="text-success" />
              <span>On Boarding </span>
            </a>
          </li>
        )}
        {isAdminRole && (
          <>
            <li className="nav-item" style={{ cursor: "pointer" }}>
              <a
                className="sidenav_link"
                onClick={() => navigate("/dashboard/adminSettings")}
                // href="/dashboard/adminSettings"
                id="UserRolesMenu"
              >
                <FaUsers title="Change User Role" className="text-info" />
                <span>User Roles</span>
              </a>
            </li>

            <li className="nav-item" style={{ cursor: "pointer" }}>
              <a
                className="sidenav_link"
                onClick={() => navigate("/dashboard/Settings")}
                id="SiteMenu"
              >
                <IoMdSettings title="Settings" className="text-dark" />
                <span>Settings</span>
              </a>
            </li>

            <li className="nav-item" style={{ cursor: "pointer" }}>
              <a
                className="sidenav_link"
                onClick={() => navigate("/dashboard/siteSettings")}
                // href="/dashboard/siteSettings"
                id="SiteMenu"
              >
                <IoMdSettings title="Site Settings" className="text-dark" />
                <span>Site Settings</span>
              </a>
            </li>

            <li className="nav-item" style={{ cursor: "pointer" }}>
              <a
                className="sidenav_link"
                onClick={() => navigate("/Blacklist")}
                // href="/dashboard/siteSettings"
                id="SiteMenu"
              >
                <FaBan title="Blacklist" className="text-dark" />
                <span>Blacklist</span>
              </a>
            </li>

            {/* <li className="nav-item">
              <a
                className="sidenav_link"
                href="/dashboard/candidateStatus"
                id="candidateStatus"
              >
                <IoMdCheckmarkCircleOutline
                  title="andidate Status"
                  className="text-danger"
                />
                <span>Candidate Status</span>
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a
                className="sidenav_link"
                href="/dashboard/CandidateStatusOrder"
                id="candidateStatusOrder"
              >
                <IoIosList
                  title="Candidate Status Order"
                  className="text-primary"
                />
                <span>Candidate Status Order</span>
              </a>
            </li> */}

          </>
        )}
      </ul>
    </div>
  );
}
